import { useMemo } from 'react'
import { RecordDetailTitles } from '@user/features/GlobalSearch/FilterDrawer/typings'

export function useGetRecordDetailTitles(): RecordDetailTitles {
  const titles = useMemo(() => {
    return [
      {
        col: [3, 3],
        key: 'pendingLead',
        title: 'Pending Lead',
      },
      {
        col: [3, 2],
        key: 'lead',
        title: 'Lead',
      },
      {
        col: [3, 3],
        key: 'opportunity',
        title: 'Opportunity',
      },
    ]
  }, [])

  return { titles }
}
